import logo from './logo.svg';
import './App.css';
import YouInMapZone from './components/YouInMapZone/YouInMapZone';

function App() {

  return (
    <YouInMapZone />
  )
}

export default App;
